{
  "barsy": {
    "article-fallback": "Артикул #{{id}}",
    "article-form": {
      "amount-type": "Мерна единица",
      "amount-type-required": "Изберете мерна единица",
      "category": "Категория",
      "create-title": "Нов артикул в Barsy",
      "no-category": "— Без категория —",
      "toast": {
        "create-error": "Грешка при създаване на артикул: {{message}}",
        "created": "Артикулът е създаден в Barsy (ID {{id}})."
      }
    },
    "config": {
      "configured": "Barsy конфигурация е зададена. Можете да я редактирате или изтриете.",
      "delete": "Изтрий",
      "delete-confirm": "Сигурни ли сте че искате да изтриете Barsy конфигурацията?",
      "delete-confirm-title": "Изтриване на Barsy конфигурация",
      "deleted": "Изтрито",
      "load-error": "Грешка при зареждане",
      "not-configured": "Няма зададена Barsy конфигурация за този клиент.",
      "password": "Barsy парола",
      "password-placeholder-new": "Задължителна при създаване",
      "password-placeholder-set": "Има зададена парола - въведете нова, ако е необходимо",
      "saved": "Запазено",
      "send-batch": "Изпращане на партида и срок на годност",
      "test": "Тествай връзката",
      "test-failed": "Неуспешна връзка",
      "test-success": "Връзката е успешна",
      "title": "Barsy настройки",
      "url": "Barsy URL",
      "username": "Barsy потребител",
      "validation": {
        "password-required": "Паролата е задължителна при първоначално създаване",
        "url-required": "URL е задължителен",
        "username-required": "Потребител е задължителен"
      }
    },
    "export": {
      "already-exported": "Този документ вече е експортиран в Barsy (ID {{id}}).",
      "attach-files": "Прикачи сканирания документ в Barsy",
      "clear-message": "Връзката със съществуващото зареждане в Barsy (ID {{id}}) ще бъде премахната и документът ще може да се експортира отново. Самото зареждане в Barsy няма да бъде изтрито.",
      "clear-title": "Импортиране като ново зареждане",
      "column": {
        "article": "Barsy артикул",
        "expiration": "Срок на годност",
        "lot": "Партида",
        "package": "Разфасовка",
        "quantity": "Количество",
        "unit-price": "Единична цена"
      },
      "create-article": "Създай нов артикул в Barsy",
      "create-supplier": "Създай нов доставчик в Barsy",
      "currency-label": "Barsy валута",
      "currency-placeholder": "Без избор",
      "depot-label": "Barsy склад",
      "depot-placeholder": "Изберете склад…",
      "doc-date": "Дата на документа",
      "doc-num": "Документ №",
      "execute": "Експорт в Barsy",
      "hide-attachments": "Скрий прикачените файлове",
      "incomplete-warning": "Попълнете всички полета (склад, доставчик и артикул за всеки ред), за да направите експорт към Barsy.",
      "item-code": "код: {{code}}",
      "lines-title": "Артикули ({{items}})",
      "load-error": "Грешка при зареждане на входящия документ.",
      "new-load": "Ново зареждане",
      "no-lines": "Документът няма редове.",
      "no-ocr": "Документът няма OCR резултат — стартирайте AI разпознаване първо.",
      "package-none": "Без",
      "package-unit": "разф.",
      "prepare-error": "Грешка при подготовка на плана. Проверете Barsy конфигурацията на клиента.",
      "re-export-hint": "Документът вече е експортиран в Barsy. Можете да опитате да го експортирате отново като ново зареждане.",
      "rematch": "Пресъпостави с AI",
      "show-attachments": "Покажи прикачените файлове",
      "title": "Експорт към Barsy на документ №{{number}}",
      "toast": {
        "clear-error": "Грешка при премахване на връзката: {{message}}",
        "cleared": "Връзката със зареждането в Barsy е премахната — документът може да бъде експортиран като ново зареждане.",
        "execute-error": "Грешка при експорт: {{message}}",
        "executed": "Документът е експортиран в Barsy (ID {{id}}).",
        "rematch-error": "Грешка при съпоставяне: {{message}}",
        "rematched": "Съпоставянето е обновено.",
        "save-error": "Грешка при запазване: {{message}}",
        "saved": "Експортът е запазен.",
        "venue-changed": "Търговският обект е сменен.",
        "venue-changed-rematched": "Търговският обект е сменен и е направено ново съпоставяне на артикулите в неговия каталог.",
        "venue-error": "Грешка при смяна на обекта: {{message}}"
      },
      "unit-prices-are": "Единичните цени са",
      "vat-excl": "Без ДДС",
      "vat-incl": "С ДДС",
      "vat-registered": "Регистрация по ДДС",
      "venue-change-message": "Обект „{{name}}“ използва различен каталог — избраните артикули ще бъдат изчистени и съпоставянето ще бъде повторено.",
      "venue-change-title": "Смяна на търговски обект",
      "venue-label": "Barsy търговски обект",
      "venue-placeholder": "Изберете обект…"
    },
    "form": {
      "create": "Създай в Barsy",
      "name": "Име",
      "no-venue": "Не е избран търговски обект в Barsy."
    },
    "match": {
      "confidence": "Увереност: {{percent}}%",
      "good": "Добро съвпадение",
      "manual": "Ръчен избор",
      "none": "Няма съвпадение",
      "partial": "Частично съвпадение",
      "suggestion-tooltip": "Предложение: <Name/> (ID {{id}})"
    },
    "open-in-barsy": "Отвори в Barsy",
    "picker": {
      "article-label": "Barsy артикул",
      "article-placeholder": "Изберете Barsy артикул",
      "supplier-label": "Barsy доставчик",
      "supplier-placeholder": "Изберете Barsy доставчик"
    },
    "supplier-fallback": "Доставчик #{{id}}",
    "supplier-form": {
      "create-title": "Нов доставчик в Barsy",
      "mol": "МОЛ",
      "toast": {
        "create-error": "Грешка при създаване на доставчик: {{message}}",
        "created": "Доставчикът е създаден в Barsy (ID {{id}})."
      },
      "vat-number": "ДДС №"
    }
  },
  "bo": {
    "form": {
      "new-title": "Нов агент",
      "new-title-named": "Нов агент: <Name/>"
    },
    "list": {
      "add": "Добави нов агент",
      "edit-tooltip": "Редактиране на агент",
      "title": "Агенти Поддръжка"
    },
    "role": {
      "admin": "Администратор",
      "helpdesk": "Поддръжка",
      "sales": "Търговски представител"
    }
  },
  "broadcast": {
    "delete-message": "Сигурни ли сте, че искате да изтриете известието <Subject/>?",
    "delete-note": "Известието ще бъде премахнато от списъка на известия на служителите",
    "delete-title": "<mark>Изтриване</mark> на известие",
    "delete-toast": "Известието {{subject}} е изтрито успешно",
    "form": {
      "create-title": "Създаване на ново известие",
      "edit-title": "Редактиране на известие {{subject}}",
      "recipients-required": "Трябва да добавите поне един получател",
      "save-draft": "Запази като чернова",
      "save-error": "Грешка при записване на известието: {{message}}. Моля опитайте отново",
      "subject-placeholder": "За какво се отнася известието"
    },
    "list": {
      "add": "Ново известие",
      "delete-tooltip": "Изтриване на известие <Subject/>",
      "edit-tooltip": "Редактиране на известие <Subject/>",
      "send-tooltip": "Изпрати известието <Subject/>",
      "title": "Изпратени известия",
      "view-tooltip": "Преглед на известие <Subject/>"
    },
    "recipients": {
      "no-location": "Няма обект",
      "title": "Избор на служители"
    },
    "send-message_one": "Сигурни ли сте, че искате да изпратите известието <Subject/> до <strong>{{count}} получател</strong>?",
    "send-message_other": "Сигурни ли сте, че искате да изпратите известието <Subject/> до <strong>{{count}} получателя</strong>?",
    "send-title": "<mark>Изпращане</mark> на известие",
    "send-toast": "Известието {{subject}} е изпратено успешно",
    "state": {
      "draft": "Чернова",
      "sent": "Изпратено"
    },
    "status": {
      "read-at": "Прочетено на",
      "read-by": "Прочетено от:",
      "recipients": "Получатели:",
      "signature": "Подпис",
      "unread": "Непрочетено"
    }
  },
  "client": {
    "access": {
      "disable-menu-tooltip": "Достъпът на избраните клиенти ще бъде прекратен",
      "disable-message": "Сигурни ли сте че искате да деактивирате следните клиенти:",
      "disable-title": "Деактивиране на клиенти",
      "disable-toast-errors": "Грешки при деактивиране: {{errors}}",
      "disable-toast-success_one": "Деактивиран {{count}} клиент",
      "disable-toast-success_other": "Деактивирани {{count}} клиента",
      "disable-toast-title": "Резултат от деактивирането на избраните клиенти",
      "enable-menu-tooltip": "Достъпът на избраните клиенти ще бъде възстановен",
      "enable-message": "Сигурни ли сте че искате да активирате следните клиенти:",
      "enable-title": "Активиране на клиенти",
      "enable-toast-errors": "Грешки при активиране: {{errors}}",
      "enable-toast-success_one": "Активиран {{count}} клиент",
      "enable-toast-success_other": "Активирани {{count}} клиента",
      "enable-toast-title": "Резултат от активирането на избраните клиенти"
    },
    "column": {
      "cloud-storage": "Облачно пространство",
      "contracted-users": "Дог. потр.",
      "expires-at": "Изтича на",
      "features": "Услуги",
      "next-payment": "Следващо плащане"
    },
    "feature": {
      "barsy-export": "Barsy експорт",
      "control-card": "Контролни карти",
      "course": "Обучение",
      "incoming-control": "Входящ контрол",
      "organizer": "Органайзер",
      "sms-notification": "SMS Известия",
      "ticket": "Сигнали"
    },
    "form": {
      "clear-date": "Изчисти",
      "company-name": "Име на фирмата",
      "contacts": "Контакти",
      "contract-end": "Край на договора",
      "contract-end-placeholder": "например 24.12.2022",
      "create-success": "Успешно създаване на {{name}}",
      "due-dates": "Падежи",
      "ext-link": "Външно досие",
      "ext-link-open": "Отвори линка",
      "feature-disable-confirm": "Сигурни ли сте че искате да деактивирате услугата \"{{feature}}\"?",
      "feature-disable-title": "Деактивиране на услуга",
      "features-label": "Активирани услуги",
      "mol": "МОЛ",
      "new-title": "Нов клиент",
      "new-title-named": "Нов клиент: <Name/>",
      "next-invoice": "Направи следваща фактура",
      "next-invoice-label": "Следваща фактура",
      "offset-months_one": "+ {{count}} месец",
      "offset-months_other": "+ {{count}} месеца",
      "offset-year": "+ 1 година",
      "payment-plan": "План за плащане",
      "quick-dates": "Бързи дати",
      "rel-previous": "Спрямо предишния падеж",
      "rel-today": "Спрямо днес",
      "tab": {
        "dossier": "Досие",
        "features": "Услуги",
        "levels": "Служители и Нива"
      },
      "today": "Днес",
      "update-success": "Успешно редактиране на {{name}}",
      "vat": "ДДС №"
    },
    "level": {
      "add": "Добави",
      "column": {
        "current": "Текущ брой служители",
        "level": "Ниво",
        "limit": "Лимит на служители"
      },
      "delete-confirm-message": "Сигурни ли сте, че искате да изтриете нивото {{level}} ({{seats}})?",
      "delete-confirm-title": "Изтриване на ниво",
      "delete-error": "Грешка при изтриване на ниво {{level}} ({{seats}})",
      "delete-success": "Успешно изтриване на ниво {{level}} ({{seats}})",
      "dialog-title": "Брой служители: {{name}}",
      "max-seats": "Брой потребители по договор",
      "save-error": "Грешка при запис на ниво {{level}} ({{seats}})",
      "save-success": "Успешен запис на ниво {{level}} ({{seats}})",
      "seats_one": "{{count}} служител",
      "seats_other": "{{count}} служителя"
    },
    "list": {
      "add": "Добави нов клиент",
      "edit-tooltip": "Редактиране на клиент",
      "export": "Експорт",
      "export-tooltip": "Експортът съдържа само резултатите на текущата страница. Увеличете размера на страницата за цялостен експорт.",
      "ext-link": "Отвори външния документ:",
      "impersonate": "Влез като клиента",
      "seats_one": "{{count}} служител",
      "seats_other": "{{count}} служителя",
      "title": "Клиенти"
    },
    "payment-plan": {
      "annual": "Годишен",
      "bi-monthly": "Двумесечен",
      "fifty-fifty": "50/50",
      "monthly": "Месечен",
      "quarterly": "Тримесечен",
      "semi-annual": "Шестмесечен"
    },
    "search": {
      "expires-from": "От дата на изтичане",
      "expires-to": "До дата на изтичане",
      "next-payment-from": "От дата на следващо плащане",
      "next-payment-to": "До дата на следващо плащане"
    },
    "storage": {
      "archived": "Архивирани (изтрити):",
      "by-type-heading": "По вид:",
      "extra": "Допълнително пространство:",
      "files_one": "{{count}} файл",
      "files_other": "{{count}} файла",
      "title": "Облачно пространство на \"{{name}}\"",
      "total": "Общо използвано:",
      "total-heading": "Общо:",
      "type": {
        "control-card-instance": "Контролни карти",
        "incoming-document": "Входящ контрол",
        "organizer-document": "Органайзер",
        "other": "Други"
      },
      "uploaded": "Качено от клиента:"
    }
  },
  "common": {
    "access-blocked": "Достъпът е блокиран",
    "access-level": "Ниво на достъп",
    "action": {
      "delete": "Изтриване",
      "edit": "Редактиране",
      "view": "Преглед"
    },
    "action-error": "Грешка при изпълнение на действието",
    "address": "Адрес",
    "attachments": {
      "add-file": "Добави файл",
      "documents-title": "Прикачени документи ({{files}}):",
      "download-pdf": "Изтегляне на PDF",
      "empty": "Няма прикачени файлове",
      "remove-tooltip": "Премахни <Name/>",
      "share": "Споделяне",
      "state-error": "Грешка при качване",
      "state-pending": "В изчакване",
      "state-uploaded": "Качен",
      "state-uploading": "Качва се",
      "uploading": "Качване... ({{percent}})",
      "view-title": "Прикачени файлове ({{files}})"
    },
    "button": {
      "back": "Назад",
      "clear": "Изчистване",
      "create": "Създай",
      "remove": "Премахни",
      "save": "Запази",
      "send": "Изпрати"
    },
    "column": {
      "actions": "Действия",
      "created-at": "Създаден на",
      "from": "От",
      "name": "Име",
      "position": "Длъжност",
      "updated-at": "Променен на"
    },
    "combo-box": {
      "clear-search": "Изчисти търсене",
      "clear-selection": "Изчисти избор",
      "no-matches": "Няма съвпадения",
      "show-options": "Покажи опции"
    },
    "content": "Съдържание",
    "date-picker": {
      "manual-entry-placeholder": "Въведете дата във формат ДД.ММ.ГГГГ"
    },
    "day-duration": {
      "days_one": "{{count}} ден",
      "days_other": "{{count}} дни"
    },
    "description": "Описание",
    "dialog": {
      "cancel": "Откажи",
      "close": "Затвори",
      "confirm": "Потвърди",
      "move": "Премести"
    },
    "eik": "ЕИК",
    "email": "Имейл",
    "error-page": {
      "message": "Грешка при зареждане на приложението. Моля опитайте отново след няколко секунди",
      "retry": "Опитай отново"
    },
    "fallback": {
      "reload": "Презареди",
      "title": "Вътрешна грешка на приложението"
    },
    "feature-disabled": {
      "contact": "Можете да заявите тази услуга по телефон <Phone/> или на email <Email/>.",
      "organizer": "Електронният органайзер Ви позволява да съхранявате важни документи за този обект, които да са достъпни по всяко време. Можете да създавате напомняния по email или SMS, когато срокът на даден документ изтича. Документите са достъпни и за служителите в тези обекти, ако им дадете съответните права.",
      "sms": "SMS известяванията позволяват изпращане на SMS съобщения, като допълнение към email или известяванията в приложението. Така можете да сте уверени, че ще получите важните известия, без да е необходимо да отваряте приложението или да проверявате електронната си поща.",
      "title": "Неактивна функционалност"
    },
    "footer": {
      "copyright": "© 2026 Еф Ес Академи ООД ⋅",
      "privacy-policy": "Политика за лични данни"
    },
    "form": {
      "default-language": "Език по подразбиране",
      "document-save-error": "Грешка при записване на документа: {{message}}. Моля опитайте отново",
      "edit-title": "Редактиране на <Name/>",
      "name-placeholder": "Моля въведете име",
      "no-language": "Без език по подразбиране",
      "password-description": "Оставете празно ако не желаете промяна",
      "recipients": "Получатели ({{recipients}})",
      "recipients-empty": "Изберете получатели",
      "repeat-password": "Повторете паролата",
      "save-failed": "Неуспешен запис"
    },
    "input": {
      "enter-number": "Въведете число",
      "enter-time": "Въведете час във формат ЧЧ:ММ",
      "enter-value": "Въведете стойност"
    },
    "language": "Език",
    "loading": "Зареждане, моля изчакайте…",
    "location": "Обект",
    "locations": "Обекти",
    "menu": {
      "archive-selected": "Архивиране на избраните",
      "disable-selected": "Деактивиране на избраните",
      "enable-selected": "Активиране на избраните",
      "restore-selected": "Възстановяване на избраните"
    },
    "not-found": "Тази страница не съществува или нямате достъп до нея.",
    "notes": "Бележки",
    "option": {
      "active": "Активни",
      "active-and-inactive": "Активни и неактивни",
      "all": "Всички"
    },
    "organizer": "Органайзер",
    "paging": {
      "all": "Всички",
      "next-page": "Следваща страница",
      "no-next-page": "Няма повече страници",
      "no-prev-page": "Няма предишна страница",
      "no-results": "Няма намерени резултати",
      "page-of": "Страница <strong>{{number}}</strong> от <strong>{{total}}</strong>",
      "per-page": "{{size}} на страница",
      "prev-page": "Предишна страница",
      "showing": "Показани <strong>{{from}}</strong> - <strong>{{to}}</strong> от <strong>{{total}}</strong> резултата по"
    },
    "password": "Парола",
    "phone": "Телефон",
    "plan": {
      "full": "Встъпително",
      "refresh": "Опреснително"
    },
    "print-dialog": {
      "export-barsy": "Експорт към Barsy",
      "export-excel": "Експорт като Excel",
      "export-pdf": "Експорт като PDF",
      "print": "Печат"
    },
    "recipients": {
      "select": "Избери ({{recipients}})"
    },
    "review": {
      "label": "Контрол",
      "pending": "За контрол",
      "reviewed": "Вече контролирани",
      "toolbar": "Контролиране …"
    },
    "rte": {
      "align-center": "Центриране",
      "align-left": "Ляво подравняване",
      "align-right": "Дясно подравняване",
      "bold": "Удебеляване",
      "bulleted-list": "Списък",
      "clear-formatting": "Изчистване на форматирането",
      "font-decrease": "По-малък текст",
      "font-increase": "По-голям текст",
      "heading": "Заглавие {{level}}",
      "highlight": "Хайлайтер",
      "indent-decrease": "Списък навън",
      "indent-increase": "Списък навътре",
      "italic": "Курсив",
      "line-break": "Нов ред",
      "numbered-list": "Номериран списък",
      "paragraph": "Текст",
      "styles": "Стилове",
      "underline": "Подчертаване"
    },
    "search": {
      "label": "Търсене",
      "submit": "Търси"
    },
    "status": "Статус",
    "subject": "Относно",
    "supplier": "Доставчик",
    "toolbar": {
      "access": "Достъп …"
    },
    "type": "Тип",
    "validation": {
      "name-required": "Името е задължително",
      "required": "Задължително"
    },
    "version": {
      "client": "Клиент",
      "server": "Сървър"
    }
  },
  "control-card": {
    "category": {
      "daily": "Ежедневна",
      "nested": "Вложена",
      "recurring": "Периодична"
    },
    "combo-box": {
      "add-list": "Добави нов списък",
      "add-title": "Нов списък с опции",
      "create": "Създай",
      "edit-title": "Редактиране на списък",
      "edit-tooltip": "Редактиране на опциите",
      "key": "Ключ",
      "key-placeholder": "Уникален идентификатор",
      "key-required": "Ключът е задължителен",
      "name-placeholder": "Описателно име",
      "options-hint": "Опции — по една на ред. Празни редове, излишните интервали и повтарящи се стойности се премахват автоматично при запис.",
      "saving": "Запазване...",
      "search-placeholder": "Търсене по име или ключ",
      "title": "Опции за текст с избор",
      "toast-created": "Списъкът \"{{name}}\" е създаден",
      "toast-saved": "Списъкът \"{{name}}\" е запазен"
    },
    "delete-instances": {
      "confirmation_one": "Сигурни ли сте, че искате да <strong>изтриете</strong> следната <strong>{{count}}</strong> контролна карта?",
      "confirmation_other": "Сигурни ли сте, че искате да <strong>изтриете</strong> следните <strong>{{count}}</strong> контролни карти?",
      "title": "<mark>Изтриване</mark> на контролни карти",
      "toast-title": "Резултат от изтриването на избраните контролни карти"
    },
    "delete-template": {
      "confirmation": "<p>Изтриването на шаблона <strong>не премахва</strong> вече съществуващите контролни карти.</p><p>Сигурни ли сте, че искате да изтриете шаблона <Name/>?</p>",
      "title": "Изтриване на <mark>шаблон</mark>",
      "toast-success_one": "Изтрит {{count}} шаблон",
      "toast-success_other": "Изтрити {{count}} шаблона",
      "toast-title": "Резултат от изтриването на избраните шаблони на контролни карти"
    },
    "delete-template-instances": {
      "confirmation": "<p>Сигурни ли сте, че искате да изтриете <strong>всички</strong> контролни карти създадени от шаблона <Name/>?</p>",
      "title": "Изтриване на <mark>контролните карти</mark>",
      "toast-title": "Резултат от изтриването на контролни карти за шаблона {{name}}"
    },
    "editor": {
      "add-column": "Добави колона",
      "block-edit-title": "Редактиране на {{label}}",
      "card-type": {
        "ad-hoc": "Без график",
        "nested": "Вложена",
        "recurring": "С възможност за график и краен срок"
      },
      "choice": {
        "add-option": "Добави опция",
        "comment-fallback": "Коментар",
        "comment-label": "Етикет на полето за коментар",
        "comment-label-hint": "Ако е оставено празно, етикетът е \"Коментар\"",
        "comment-label-view": "(Етикет на коментара: <Value/>)",
        "delete-confirm": "Сигурни ли сте, че искате да изтриете опция \"{{text}}\"?",
        "delete-title": "Изтриване на опция \"{{text}}\"",
        "edit-title": "Редактиране на опция \"{{text}}\"",
        "key-tooltip": "Ключ: <Key/>",
        "new-title": "Нова опция",
        "no-options": "Няма добавени опции"
      },
      "choice-type": {
        "single": "Избор",
        "with-comment": "Избор с коментар"
      },
      "collapse": "Скрий",
      "column": {
        "add-tooltip": "Добавяне на нова колона след <Name/>",
        "boundary": "Диапазон за максимална и минимална стойност",
        "boundary-hint": "Ако е попълнен, потребителят няма да може да въведе или избере стойности извън този диапазон.",
        "choice-options": "Опции за избор",
        "copy-tooltip": "Създаване на нова колона като се използва <Name/> за основа",
        "default-value": "Стойност по подразбиране",
        "default-value-hint": "Това е стойността, която ще бъде <strong>попълнена</strong> автоматично при създаването на контролната карта",
        "default-value-of": "Стойност по подразбиране на колона \"{{title}}\"",
        "delete-confirm": "Сигурни ли сте, че искате да изтриете колона \"{{title}}\"?",
        "delete-title": "Изтриване на колона \"{{title}}\"",
        "delete-tooltip": "Изтриване на <Name/>",
        "description-hint": "Допълнителен пояснителен текст с цел улесняване на потребителя при попълване на тази стойност",
        "edit-title": "Редактиране на колона \"{{title}}\"",
        "edit-tooltip": "Редактиране на <Name/>",
        "employee-groups": "Групи служители",
        "employee-groups-hint": "Ако е избрана поне една група, в избора на служители ще се покажат само хората от тези групи.",
        "expression": "Формула за стойност",
        "expression-hint": "Тази формула изчислява стойността на колоната",
        "green-zone": "Диапазон за \"Зелена зона\"",
        "green-zone-hint": "Ако е попълнен, стойностите в избрания диапазон ще бъдат оцветени в зелено, а извън него - в червено.",
        "group-archived": "{{name}} (архивирана)",
        "groups-all": "Всички",
        "icon-set": "Икони за увеличаване и намаляване на числото",
        "initial-value": "Начална стойност",
        "initial-value-hint": "Това е стойността, която ще бъде <strong>предложена</strong> на потребителя",
        "initial-value-of": "Начална стойност на колона \"{{title}}\"",
        "input-method": "Начин на въвеждане",
        "key": "Ключ",
        "key-required": "Ключът е задължителен",
        "list-key": "Ключ към списък",
        "lock-tooltip": "Когато основната колона е маркирана заключена, тя не може да бъде редактирана в контролната карта. Тази колона може да бъде избрана <Em>само</Em> при добавяне на нов запис.",
        "locked": "Заключена",
        "make-primary-tooltip": "Направи <Name/> основна колона",
        "move-down-tooltip": "Преместване на <Name/> надолу",
        "move-up-tooltip": "Преместване на <Name/> нагоре",
        "must-select-icons": "Трябва да изберете икони",
        "must-select-input-method": "Трябва да изберете вид на въвеждане",
        "must-select-list-key": "Трябва да изберете ключ към списък",
        "must-select-nested": "Трябва да изберете вложена карта",
        "new-title": "Нова колона",
        "no": "Не",
        "no-expression": "Няма формула",
        "no-initial-value": "Без начална стойност",
        "no-range": "Няма диапазон",
        "no-unit": "Без мерна единица",
        "open-camera": "Директно отваряне на камерата",
        "open-camera-hint": "При качване от телефон камерата се отваря директно, без диалог за избор на файл. Могат да се качват само снимки.",
        "options": "Опции",
        "show-expression": "Формула за скриване / показване",
        "show-expression-hint": "Тази формула изчислява дали колоната трябва да бъде скрита или показана",
        "title-label": "Име на колона",
        "unit": "Мерна единица",
        "user-groups": "Групи потребители",
        "user-groups-hint": "Ако е избрана поне една група, получателите на сигнала ще бъдат филтрирани по тези групи.",
        "validation": "Валидация",
        "validation-hint": "Няма да позволи приключването на реда, ако стойността не отговаря на условията.",
        "yes": "Да"
      },
      "column-type": {
        "attachment": "Снимка",
        "choice": "Избор (единичен)",
        "combo-box": "Текст (с избор)",
        "date": "Дата",
        "employee-ref": "Служител",
        "label": "Етикет",
        "multi-choice": "Избор (множествен)",
        "nested": "Вложена карта",
        "number": "Число",
        "signature": "Подпис",
        "text": "Текст",
        "ticket": "Сигнал",
        "time": "Час",
        "transposed": "Транспонирана"
      },
      "columns": "Колони",
      "definition": {
        "invalid-json": "Невалиден JSON обект: {{message}}",
        "label": "Шаблон",
        "placeholder": "Моля въведете шаблон"
      },
      "expand": "Разгледай",
      "form": {
        "copy-rows": "Копиране на последната карта при създаване по график",
        "due-to": "Краен час на попълване в рамките на деня",
        "dynamic-rows": "Добавяне или премахване на редове",
        "footer-text": "Помощен текст под таблицата",
        "header-text": "Помощен текст над таблицата",
        "help-text": "Помощен текст",
        "schedule": "График за автоматично създаване",
        "type": "Тип"
      },
      "icon-set": {
        "number": "Минус / Плюс",
        "temperature": "Студено / Топло"
      },
      "input-method": {
        "discrete": "Въвеждане със слайдер",
        "free": "Въвеждане с клавиатура"
      },
      "kind": "Вид",
      "no-columns": "Няма колони в този шаблон",
      "number-input": {
        "action-text": "Етикет на действието",
        "action-text-hint": "Това е текстът, който ще пише на бутона при въвеждане със слайдер или като пояснителен текст в полето за въвеждане на число от клавиатурата",
        "action-text-placeholder": "Примерно \"Изберете температура\", \"Въведете тегло\" или друго",
        "action-text-view": "Етикет на действието: <Value/>",
        "edit-title": "Редактиране на начин на въвеждане на число",
        "method-label": "Начин на въвеждане на числото",
        "range-required": "Трябва да изберете начало и край на слайдера",
        "slider-range": "Начало и край на слайдера",
        "slider-range-hint": "Минималната и максималната стойност, която може да се избира със слайдера",
        "step": "Стъпка",
        "step-hint-discrete": "През каква стойност ще са опциите за избор в слайдера, и с колко да се увеличава и намалява числото при натискане на бутоните за + и -.",
        "step-hint-free": "С колко да се увеличава и намалява числото при натискане на бутоните за + и -.",
        "step-required": "Трябва да изберете стъпка"
      },
      "range": {
        "above": "над <Num/>",
        "below": "под <Num/>",
        "edit-title": "Редактиране на диапазон",
        "field-required": "Това поле е задължително",
        "from": "От",
        "none": "Без диапазон",
        "remove-tooltip": "Премахни диапазона",
        "to": "До"
      },
      "range-type": {
        "closed": "От - до",
        "open-end": "От",
        "open-start": "До"
      },
      "template": {
        "base-group": "Базови шаблони",
        "cold-dish-temp": "Температура на съхранение на студено ястие",
        "compliance": "Съответства / Не съответства",
        "empty-ad-hoc": "Празна карта без график",
        "empty-recurring": "Празна карта с възможност за график",
        "empty-transposed": "Празна карта с един ред",
        "expiry-check": "Проверка срок на годност",
        "freezer": "Фризер",
        "fridge": "Хладилник",
        "fridge-display": "Хладилна витрина",
        "hot-dish-temp": "Вътрешна температура на топло ястие",
        "humidity": "Влажност",
        "hygiene": "Хигиена",
        "notes": "Бележки",
        "transposed": "Транспонирана"
      },
      "validation": {
        "badge-absolute": "АБСОЛЮТНО задължително",
        "badge-with-comment": "Задължително с коментар",
        "edit-title": "Редактиране на валидация",
        "message-hint": "Това е текстът, който ще се появи, ако няма въведена стойност в тази колона.",
        "message-label": "Съобщение при грешка",
        "message-required": "Това поле е задължително",
        "message-view": "Съобщение: <Message/>",
        "none": "Без валидация",
        "override-label": "Може ли да се пренебрегне",
        "override-no": "Не, полето е АБСОЛЮТНО задължително",
        "override-yes": "Да, служителят може да го пропусне с КОМЕНТАР"
      },
      "validation-type": {
        "required": "Задължително поле"
      },
      "value": {
        "choice-options": "Възможни опции",
        "comment-for-option": "{{label}} (за опция {{option}}): ",
        "edit-title": "Редактиране на {{label}}",
        "employee-ref": "Служител [{{id}}]",
        "empty-text": "Празен текст",
        "expression-result": "Резултатът от формулата",
        "field-required": "Полето е задължително",
        "nested-auto-create": "Вложена карта (Автоматично създаване)",
        "nested-manual-create": "Вложена карта (Ръчно създаване)",
        "no-selected-values": "Няма избрани стойности",
        "no-value": "Без стойност",
        "null-value": "Няма стойност",
        "options-required": "Трябва да създадете опции преди да изберете стойност",
        "photos-existing": "Снимки ({{id}})",
        "photos-new": "Снимки (създаване)"
      },
      "value-type": {
        "attachment": "Снимка",
        "auto-create": "Автоматично създаване",
        "choice": "Избор",
        "date": "Дата",
        "employee-ref": "Препратка към Служител",
        "empty": "Без стойност",
        "expression": "Формула",
        "manual-create": "Ръчно създаване",
        "multi-choice": "Множествен избор",
        "number": "Число",
        "rich-text": "Текст с форматиране",
        "signature": "Подпис",
        "text": "Текст",
        "time": "Час"
      }
    },
    "export-panel": {
      "cards_one": "{{count}} карта",
      "cards_other": "{{count}} карти",
      "delete-aria": "Изтрий",
      "delete-confirmation": "Ще бъдат изтрити <strong>само експортът</strong> и генерираните от него PDF файлове. Самите контролни карти <strong>остават непроменени</strong>. Продължаване?",
      "delete-title": "Изтриване на експорт",
      "delete-tooltip": "Изтрий експорта и генерираните файлове",
      "duration-tooltip": "Продължителност на експорта: {{duration}}",
      "estimated-end": "очакван край: <Ts/>",
      "no-recent": "Няма скорошни експорти.",
      "retention-note": "Готовите експорти са достъпни за изтегляне 30 дни след създаването им, след което се изтриват автоматично.",
      "status": {
        "deleting": "Изтрива се",
        "done": "Готов",
        "failed": "Грешка",
        "queued": "Изчаква",
        "running": "Генерира се",
        "stopped": "Спрян",
        "stopping": "Спира се"
      },
      "stop-aria": "Спри",
      "stop-confirmation": "Генерирането на PDF файловете ще бъде <strong>прекратено</strong>. Спреният експорт <strong>не може да бъде продължен</strong>. Продължаване?",
      "stop-title": "Спиране на експорт",
      "stop-tooltip": "Спри експорта",
      "title": "Експорт на контролни карти"
    },
    "instance-list": {
      "column": {
        "date": "Дата",
        "due-to": "Краен срок",
        "status": "Статус"
      },
      "delete-tooltip": "Изтрий тази контролна карта",
      "edit-template-tooltip": "Редактирай шаблона на тази карта",
      "export": {
        "all-results": "На всички резултати",
        "all-results-title": "Всички контролни карти, отговарящи на текущия филтър, ще бъдат генерирани като PDF файлове в ZIP архив",
        "confirm-all-filtered": "Ще бъде стартиран експорт на <strong>всички карти, отговарящи на текущия филтър</strong>, като PDF файлове в ZIP архив. Продължаване?",
        "confirm-month": "Ще бъде стартиран експорт на <strong>всички</strong> контролни карти за <Month/> като PDF файлове в ZIP архив. Продължаване?",
        "confirm-selected_one": "Ще бъде стартиран експорт на <strong>{{count}}</strong> контролна карта като PDF файлове в ZIP архив. Продължаване?",
        "confirm-selected_other": "Ще бъде стартиран експорт на <strong>{{count}}</strong> контролни карти като PDF файлове в ZIP архив. Продължаване?",
        "create-section": "Създай експорт",
        "current-month": "За текущия месец",
        "current-month-title": "Всички контролни карти за текущия месец ще бъдат генерирани като PDF файлове в ZIP архив",
        "dialog-title": "Експорт на контролни карти",
        "download-section": "Свали експорт",
        "previous-month": "За предходния месец",
        "previous-month-title": "Всички контролни карти за предходния месец ще бъдат генерирани като PDF файлове в ZIP архив",
        "recent": "Скорошни експорти",
        "selected": "На избраните {{suffix}}",
        "selected-title": "Избраните контролни карти ще бъдат генерирани като PDF файлове в ZIP архив"
      },
      "mark-na": {
        "mark-selected": "Отбележи като неприложими избраните {{suffix}}",
        "mark-selected-title": "Избраните контролни карти ще бъдат отбелязани като неприложими за този ден",
        "toast-errors": "Грешки при отбелязването: {{errors}}",
        "toast-success_one": "Отбелязана като неприложима {{count}} контролна карта",
        "toast-success_other": "Отбелязани като неприложими {{count}} контролни карти",
        "toast-title": "Резултат от отбелязването като неприложими на контролни карти"
      },
      "print-tooltip": "Отпечатай тази контролна карта",
      "rebuild-tooltip": "Създай отново тази контролна карта от текущия шаблон",
      "report": {
        "all": "Всички проверки",
        "create-selected": "Създай нова проверка за избраните {{suffix}}"
      },
      "review": {
        "mark-selected": "Отбележи като контролирани избраните {{suffix}}",
        "mark-selected-title": "Избраните контролни карти ще бъдат отбелязани като проконтролирани от вас",
        "toast-errors": "Грешки при проконтролиране: {{errors}}",
        "toast-success_one": "Проконтролирана {{count}} контролна карта",
        "toast-success_other": "Проконтролирани {{count}} контролни карти",
        "toast-title": "Резултат от отбелязването като проконтролирани контролни карти"
      },
      "status": {
        "completed": "Попълнена",
        "completed-tooltip": "От <Name/> на <Ts/>",
        "incomplete": "Непопълнена",
        "not-applicable": "Неприложима",
        "not-applicable-tooltip": "Отбелязана от <Name/> на <Ts/> с причина <Reason/>",
        "past-due": "Просрочена"
      },
      "template-missing-tooltip": "Шаблонът за тази карта вече не съществува",
      "title": "Контролни карти",
      "toolbar": {
        "delete": "Изтриване",
        "delete-tooltip_one": "Изтриване на избраната <strong>{{count}}</strong> контролна карта",
        "delete-tooltip_other": "Изтриване на избраните <strong>{{count}}</strong> контролни карти",
        "export": "Експорт …",
        "export-tooltip": "Експорт на избраните контролни карти като PDF файлове в ZIP архив",
        "mark-na": "Отбелязване като неприложими …",
        "mark-na-tooltip": "Маркирай избраните контролни карти като неприложими, поради почивен ден на обекта или по други причини",
        "report": "Проверка",
        "report-tooltip": "Създаване на проверка"
      },
      "unmark-na": {
        "mark-selected": "Отмени неприложимост на избраните {{suffix}}",
        "mark-selected-title": "Ще се изчисти неприложимостта на избраните контролни карти",
        "toast-errors": "Грешки при отмяната: {{errors}}",
        "toast-success_one": "Отменена неприложимостта на {{count}} контролна карта",
        "toast-success_other": "Отменена неприложимостта на {{count}} контролни карти",
        "toast-title": "Резултат от отменянето на неприложимостта на контролни карти"
      },
      "unreview": {
        "mark-selected": "Отмени контролирането на избраните {{suffix}}",
        "mark-selected-title": "Ще се изчисти контролираното състояние на избраните контролни карти",
        "toast-errors": "Грешки при отмяната: {{errors}}",
        "toast-success_one": "Отменен контрола на {{count}} контролна карта",
        "toast-success_other": "Отменен контрола на {{count}} контролни карти",
        "toast-title": "Резултат от отменянето на контрола върху контролни карти"
      }
    },
    "mark-na-dialog": {
      "quick-reason-day-off": "Почивен ден",
      "quick-reason-holiday": "Официален празник",
      "quick-reason-not-applicable": "Неприложима за този ден",
      "quick-reasons": "Чести причини:",
      "reason": "Причина",
      "reason-required": "Причината е задължителна",
      "submit": "Отбележи",
      "title": "Отбелязване като неприложими"
    },
    "rebuild": {
      "confirmation": "Сигурни ли сте, че искате да обновите контролната карта?",
      "title": "Обновяване на контролна карта",
      "toast-errors": "Грешки при обновяването: {{errors}}",
      "toast-success_one": "Обновена {{count}} контролна карта",
      "toast-success_other": "Обновени {{count}} контролни карти",
      "toast-title": "Резултат от обновяването на избраните контролни карти"
    },
    "report": {
      "create": {
        "estimate-size": "Оцени размера",
        "prompt-label": "Критерий за проверка",
        "prompt-required": "Критерият за проверка е задължителен",
        "size": "Размер:",
        "start": "Стартирай",
        "title": "Създаване на проверка",
        "unknown-size": "Неизвестно"
      },
      "details": {
        "status": "Статус",
        "title": "Проверка №{{id}}"
      },
      "list": {
        "column": {
          "completed": "Приключен",
          "details": "Детайли"
        },
        "export": "Експорт",
        "export-tooltip": "Експортът съдържа само резултатите на текущата страница. Увеличете размера на страницата за цялостен експорт.",
        "open": "Отвори",
        "title": "Списък с проверки"
      },
      "price": "Цена",
      "price-tooltip": "{{usd}}, курс {{rate}} за $1, модел {{model}}",
      "prompt": "Промпт",
      "result": "Резултат",
      "status-completed": "Приключен",
      "status-running": "Работи"
    },
    "review-status": {
      "not-reviewed-tooltip": "Не е проконтролирано",
      "reviewed-tooltip": "Проконтролирано от <Name/> на <Ts/>"
    },
    "search": {
      "all-categories": "Всички категории",
      "category": "Категория",
      "date-from": "От дата",
      "date-to": "До дата",
      "status": "Статус",
      "status-any": "Без значение",
      "status-completed": "Попълнени",
      "status-incomplete": "Непопълнени"
    },
    "template-form": {
      "back": "Назад",
      "category-label": "Категория на карта",
      "client-templates": "Шаблони на клиента",
      "edit-title": "Редактиране на <Name/> за обект <Location/>",
      "name-label": "Име на карта",
      "new-template": "Нов шаблон",
      "new-title": "Нов шаблон за обект <Location/>",
      "new-title-named": "Нов шаблон: <Name/> за обект <Location/>",
      "save-error": "Грешка при записване на шаблона: {{message}}",
      "tab-code": "Код",
      "tab-editor": "Редактор",
      "toast-saved": "Успешен запис на шаблон {{name}}",
      "validation-error": "Грешка при валидация на шаблона"
    },
    "template-list": {
      "add-template": "Добави нов шаблон",
      "column": {
        "category": "Категория"
      },
      "combo-box-options": "Опции за текст с избор",
      "delete-instances-tooltip": "Изтрий всички <strong>контролни карти</strong> създадени от този шаблон",
      "delete-template-tooltip": "Изтрий този <strong>шаблон</strong> на контролна карта",
      "edit-template-tooltip": "Редактиране на шаблона",
      "title": "Шаблони за контролни карти за обект <Location/>"
    },
    "toast": {
      "delete-errors": "Грешки при изтриване: {{errors}}",
      "deleted-instances_one": "Изтрита {{count}} контролна карта",
      "deleted-instances_other": "Изтрити {{count}} контролни карти"
    }
  },
  "employee": {
    "access-code": {
      "copied": "Кодът на <Name/> е успешно копиран",
      "copy-failed": "Копирането на кода е неуспешно",
      "copy-tooltip": "Копирай кода и кратки инструкции"
    },
    "column": {
      "access-code": "Код за достъп",
      "completed": "Завършени",
      "in-progress": "Текущо обучение",
      "level": "Ниво"
    },
    "form": {
      "access-code-hint": "Кодът за достъп се генерира автоматично след запис на служителя",
      "dob": "Дата на раждане",
      "dob-description": "Не е задължителна, само ако има двама или повече служители <strong>с напълно съвпадащи имена</strong>",
      "dob-placeholder": "например 24.12.2012",
      "name-placeholder": "Моля въведете името на служителя",
      "new-title": "Нов служител",
      "new-title-named": "Нов служител: <Name/>",
      "no-level": "Без обучение",
      "no-locations": "Без обекти",
      "no-position": "Без длъжност",
      "save-error": "Грешка при записване на служителя: {{message}}. Моля опитайте отново",
      "save-success": "Успешен запис на служител {{name}}"
    },
    "level": {
      "free-seats_one": "Свободно {{count}} място",
      "free-seats_other": "Свободни {{count}} места",
      "full-seats_one": "Запълнено {{count}} място",
      "full-seats_other": "Запълнени всички {{count}} места",
      "occupied-seats": "Заети {{occupied}} от {{total}} места"
    },
    "level-label": "Ниво за обучение",
    "list": {
      "add": "Добави нов служител",
      "change-level": "Смени ниво на избраните …",
      "create-protocol": "Създай протокол …",
      "disable-hint": "Достъпът на избраните служители ще бъде прекратен и ще бъдат освободени места за нови",
      "disable-message_one": "Сигурни ли сте че искате да деактивирате следния служител:",
      "disable-message_other": "Сигурни ли сте че искате да деактивирате следните служители:",
      "disable-title": "Деактивиране на служители",
      "disable-toast-errors": "Грешки при деактивиране: {{errors}}",
      "disable-toast-success_one": "Деактивиран {{count}} служител",
      "disable-toast-success_other": "Деактивирани {{count}} служители",
      "disable-toast-title": "Резултат от деактивирането на избраните служители",
      "edit-tooltip": "Редактиране на служител",
      "enable-hint": "Достъпът на избраните служители ще бъде възстановен",
      "enable-message_one": "Сигурни ли сте че искате да активирате следния служител:",
      "enable-message_other": "Сигурни ли сте че искате да активирате следните служители:",
      "enable-title": "Активиране на служители",
      "enable-toast-errors": "Грешки при активиране: {{errors}}",
      "enable-toast-success_one": "Активиран {{count}} служител",
      "enable-toast-success_other": "Активирани {{count}} служители",
      "enable-toast-title": "Резултат от активирането на избраните служители",
      "export": "Експорт",
      "export-tooltip": "Експортът съдържа само резултатите на текущата страница. Увеличете размера на страницата за цялостен експорт.",
      "level-change-message_one": "Сигурни ли сте че искате да смените нивото на следния служител на <Name/>:",
      "level-change-message_other": "Сигурни ли сте че искате да смените нивото на следните служители на <Name/>:",
      "level-change-title": "Смяна на нивото на служители",
      "level-change-toast-errors": "Грешки при промяната на нивото: {{errors}}",
      "level-change-toast-success_one": "Променено ниво на {{count}} служител",
      "level-change-toast-success_other": "Променено ниво на {{count}} служители",
      "level-change-toast-title": "Резултат от промяната на нивото на избраните служители",
      "login-as-tooltip": "Влез като този служител",
      "no-level": "Няма ниво",
      "no-level-inline": "няма ниво",
      "no-location": "Няма обект",
      "no-position": "Няма длъжност",
      "title": "Служители"
    },
    "permission": {
      "add-inc-doc": "Добавяне на документи",
      "edit-control-card": "Попълване на контролни карти",
      "edit-organizer": "Редактиране на органайзер",
      "edit-other-inc-doc": "Редакция на документи на други служители",
      "edit-own-inc-doc": "Редакция на собствени документи",
      "group": {
        "control-card": "Контролни карти",
        "inc-doc": "Входящ контрол"
      },
      "help": {
        "add-inc-doc": "Служителят ще може да <strong>добавя документи</strong> във входящия контрол за този обект.",
        "edit-control-card": "Служителят ще може да <strong>създава или попълва вече създадени</strong> контролни карти — от <strong>днешния ден и избрания брой дни назад</strong>. При „0 дни“ се попълват само карти от днешния ден. По-старите контролни карти ще бъдат недостъпни за редакция.",
        "edit-organizer": "Служителят ще може да <strong>добавя, редактира и изтрива</strong> документи в органайзера за този обект.",
        "edit-other-inc-doc": "Служителят ще може да редактира <strong>документи, създадени от други служители</strong> във Входящия контрол — от <strong>днешния ден и избрания брой дни назад</strong>. При „0 дни“ се редактират само документи от днешния ден. По-старите документи ще бъдат недостъпни за редакция.",
        "edit-own-inc-doc": "Служителят ще може да редактира <strong>своите документи</strong> във входящия контрол — от <strong>днешния ден и избрания брой дни назад</strong>. При „0 дни“ се редактират само документи от днешния ден. По-старите документи ще бъдат недостъпни за редакция.",
        "view-control-card": "Служителят ще има достъп до <strong>контролните карти</strong> за този обект.",
        "view-inc-doc": "Служителят ще има достъп до <strong>входящия контрол</strong> за този обект.",
        "view-organizer": "Служителят ще има достъп до <strong>органайзера</strong> за този обект."
      },
      "no-limit": "Без ограничение",
      "time-limit": "до <Input/> назад",
      "title": "Права на достъп",
      "tooltip-no-limit": "(без ограничение)",
      "tooltip-time-limit": "(до <Dur/> назад)",
      "tooltip-today-only": "(само за текущия ден)",
      "view-control-card": "Достъп до \"Контролни карти\"",
      "view-inc-doc": "Достъп до \"Входящ контрол\"",
      "view-organizer": "Достъп до \"Органайзер\""
    },
    "plan": {
      "refresh": "Опреснително ({{from}} - {{to}})"
    },
    "progress": {
      "completed-at": "Завършено на <Date/> със среден успех {{score}}",
      "last-answer": "Последният отговор е даден на <Ts/>",
      "lesson-completed-at": "Завършена на <Date/> с успех {{score}}.",
      "lesson-started-at": "Започната на <Date/>",
      "lessons-progress_one": "Завършени {{completed}} от {{count}} тема ({{percent}}) със среден успех {{score}}",
      "lessons-progress_other": "Завършени {{completed}} от {{count}} теми ({{percent}}) със среден успех {{score}}",
      "no-current": "Няма текущо обучение",
      "overdue_one": "Просрочено с <strong>{{count}} ден</strong>",
      "overdue_other": "Просрочено с <strong>{{count}} дни</strong>",
      "period": "(срок от <From/> до <To/>)",
      "required-question-failed": "Има сбъркан задължителен въпрос",
      "test-not-submitted_one": "Тестът не е предаден. Отговорени {{answered}} от {{count}} въпрос, от които {{correct}} са правилни.",
      "test-not-submitted_other": "Тестът не е предаден. Отговорени {{answered}} от {{count}} въпроса, от които {{correct}} са правилни.",
      "test-result": "Текущ резултат от теста {{current}} при мин. {{min}}.",
      "watched": "Изгледани {{percent}}"
    },
    "protocol": {
      "all-results": "За всички резултати",
      "all-results-hint": "На всички служители, които отговарят на текущите филтри",
      "current-page": "За текущата страница",
      "current-page-hint": "Само за служителите от текущата страница",
      "header": "Протокол",
      "include-plans-header": "Да включва следните обучения",
      "selected": "Само за избраните {{suffix}}",
      "selected-hint": "Само за избраните служители от текущата страница"
    },
    "search": {
      "access": "Достъп",
      "completed-from": "От дата на завършване",
      "completed-to": "До дата на завършване"
    }
  },
  "incdoc": {
    "barsy-status": {
      "exported": "Експортиран към Barsy на <Ts/>",
      "not-exported": "Не е експортиран към Barsy"
    },
    "form": {
      "add-title": "Добави документ",
      "ai-no-results": "Не разпознахме с AI",
      "ai-results": "Разпознахме с AI",
      "date": "Дата на документ",
      "date-placeholder": "Въведете датата на документа",
      "edit-supplier": "Редактиране на {{name}}",
      "edit-title": "Редактиране на документ {{number}}",
      "fill-with-ai": "Попълни с AI",
      "location-placeholder": "Изберете обекта, за който е документа",
      "mark-reviewed": "Отбележи като контролиран",
      "new-supplier": "Нов доставчик",
      "notes-placeholder": "Допълнителни бележки (ако има нужда)",
      "number": "Номер на документ",
      "number-placeholder": "Въведете номера на документа",
      "supplier-placeholder": "Изберете доставчика, който е издал документа"
    },
    "list": {
      "add-document": "Добави нов документ",
      "ai-dialog-title": "Разпознаване с AI",
      "ai-preview-tooltip": "Преглед на AI резултат за документ №<Num/>",
      "ai-schedule-tooltip": "Разпознаване с AI на документ №<Num/>",
      "ai-scheduled": "Разпознаването с AI на документ №<Num/> е насрочено.<br/>Очаквано време: <Ts/>",
      "column": {
        "created-by": "Създаден от",
        "date": "Дата",
        "export": "Експорт",
        "files": "Файлове",
        "number": "Номер",
        "supplier": "Доставчик"
      },
      "delete-confirmation": "Сигурни ли сте, че искате да изтриете документ <Num/>",
      "delete-title": "<mark>Изтриване</mark> на документ",
      "delete-toast": "Документ №{{number}} е изтрит успешно",
      "delete-tooltip": "Изтриване на документ №<Num/>",
      "download-pdf-tooltip": "Изтегляне на документ №<Num/> като PDF",
      "edit-tooltip": "Редактиране на документ №<Num/>",
      "review": {
        "mark-selected": "Отбележи като контролирани избраните {{suffix}}",
        "mark-selected-title": "Избраните документи ще бъдат отбелязани като проконтролирани от вас",
        "toast-errors": "Грешки при проконтролиране: {{errors}}",
        "toast-success_one": "Проконтролиран {{count}} документ",
        "toast-success_other": "Проконтролирани {{count}} документи",
        "toast-title": "Резултат от отбелязването като проконтролирани документи"
      },
      "unreview": {
        "mark-selected": "Отмени контролирането на избраните {{suffix}}",
        "mark-selected-title": "Ще се изчисти контролираното състояние на избраните документи",
        "toast-errors": "Грешки при отмяната: {{errors}}",
        "toast-success_one": "Отменен контрола на {{count}} документ",
        "toast-success_other": "Отменен контрола на {{count}} документи",
        "toast-title": "Резултат от отменянето на контрола върху документи"
      },
      "view-files": "Виж ({{files}})"
    },
    "ocr": {
      "apply-selected": "Попълни избраните",
      "badge-existing": "Съществуващ",
      "badge-new": "Нов",
      "create-new": "Създай нов: {{name}}",
      "document-date": "Дата на документа: <Dt/>",
      "document-number": "Номер на документ: <Num/>",
      "no-results-text": "Не успяхме да разпознаем данни от документите. Моля, направете по-ясна снимка — уверете се, че има достатъчно светлина и целият документ се вижда в кадъра.",
      "no-results-title": "Документите не бяха разпознати с AI",
      "supplier": "Доставчик: <Name/>",
      "title": "Сверете разпознатите атрибути с документа",
      "use-existing": "Използвай съществуващ: {{name}}"
    },
    "search": {
      "created-from": "От дата на създаване",
      "created-to": "До дата на създаване",
      "doc-date-from": "От дата на документа",
      "doc-date-to": "До дата на документа",
      "suppliers": "Доставчици"
    },
    "supplier": {
      "add-title": "Добави доставчик",
      "edit-title": "Редактиране на доставчик {{name}}",
      "eik-placeholder": "Въведете ЕИК на доставчика",
      "name": "Име на доставчик",
      "name-placeholder": "Въведете името на доставчика"
    }
  },
  "level": {
    "column": {
      "video-lessons": "Видео уроци в нивото"
    },
    "form": {
      "new-title": "Ново ниво",
      "new-title-named": "Ново ниво: <Name/>",
      "video-lessons": "Избрани теми"
    },
    "list": {
      "add": "Добави ново ниво",
      "edit-tooltip": "Редактиране на ниво",
      "title": "Нива"
    }
  },
  "location": {
    "archive": {
      "intro_one": "Архивиране на следния обект:",
      "intro_other": "Архивиране на следните {{count}} обекта:",
      "keeps-control-cards": "Всички шаблони на контролни карти, както и попълнените вече контролни карти",
      "keeps-incdoc": "Всички документи от Входящ контрол",
      "keeps-lead": "Архивирането <strong>запазва</strong>, но прави недостъпни до възстановяване на обекта:",
      "keeps-organizer": "Органайзерът на обекта",
      "question": "Сигурни ли сте, че искате да архивирате избраните обекти?",
      "removes-lead": "Архивирането <strong>премахва</strong> и <strong>не могат да бъдат възстановени</strong>:",
      "removes-memberships": "Принадлежността на служители и управители към обекта. Самите служители и управители се запазват",
      "removes-permissions": "Всички права на служители върху обекта",
      "stops-lead": "Архивирането <strong>спира</strong> до възстановяване на обекта:",
      "stops-notifications": "Всички известия по всички канали за известяване (email, SMS и в приложението)",
      "stops-scheduled-cards": "Създаването на ежедневните и периодичните контролни карти с график",
      "title": "Архивиране на обекти",
      "toast-errors": "Грешки при архивиране: {{errors}}",
      "toast-success_one": "Архивиран {{count}} обект",
      "toast-success_other": "Архивирани {{count}} обекта",
      "toast-title": "Резултат от архивирането на избраните обекти"
    },
    "column": {
      "control-cards": "Контролни карти"
    },
    "form": {
      "address-placeholder": "Моля въведете адрес",
      "new-title": "Нов обект",
      "new-title-named": "Нов обект: <Name/>",
      "save-error": "Грешка при записване на обекта: {{message}}. Моля опитайте отново",
      "save-success": "Успешен запис на обект {{name}}"
    },
    "list": {
      "add": "Добави нов обект",
      "archive-hint": "Избраните обекти ще бъдат архивирани",
      "archived-tooltip": "Обектът е архивиран",
      "create-organizer": "Създай органайзер",
      "edit-tooltip": "Редактиране на обект",
      "no-templates": "Няма",
      "restore-hint": "Избраните обекти ще бъдат възстановени",
      "templates-tooltip": "Шаблони за контролни карти"
    },
    "restore": {
      "intro_one": "Възстановяване на следния обект:",
      "intro_other": "Възстановяване на следните {{count}} обекта:",
      "manual-note": "<strong>Те трябва да се възстановят ръчно.</strong>",
      "not-restored-lead": "Възстановяването на обекта <strong>не възстановява</strong> следните връзки:",
      "not-restored-memberships": "Принадлежността на служители и управители към обекта",
      "not-restored-permissions": "Правата на служители върху обекта",
      "question": "Сигурни ли сте, че искате да възстановите избраните обекти?",
      "restores-control-cards": "Достъпа до попълнените вече контролни карти преди архивирането на обекта",
      "restores-incdoc": "Достъпа до всички документи от Входящ контрол",
      "restores-lead": "Възстановява се:",
      "restores-notifications": "Подновяват се известията по всички канали за известяване (email, SMS и в приложението)",
      "restores-organizer": "Достъпа до органайзера на обекта",
      "restores-scheduled-cards": "Подновява се създаването на ежедневните и периодичните контролни карти с график",
      "title": "Възстановяване на обекти",
      "toast-errors": "Грешки при възстановяване: {{errors}}",
      "toast-success_one": "Възстановен {{count}} обект",
      "toast-success_other": "Възстановени {{count}} обекта",
      "toast-title": "Резултат от възстановяването на избраните обекти"
    },
    "search": {
      "only-archived": "Само архивирани"
    }
  },
  "login": {
    "bo-failed": "Неуспешен вход. Моля опитайте отново",
    "bo-title": "Вход за администрация на FSAcademy",
    "disabled-bo": "Влезте като друг администратор",
    "disabled-manager": "Влезте като друг управител",
    "disabled-title": "Вашият достъп е деактивиран",
    "forgot-instructions": "Въведете имейла, който използвате за вход. Ще получите съобщение с линк, чрез който можете да влезете директно в акаунта си.",
    "forgot-link": "Забравена парола",
    "forgot-success": "Ако има акаунт, регистриран с <strong>{{email}}</strong>, ще получите имейл с инструкции. Проверете <strong>входящата си поща</strong>, както и папката за <strong>Спам</strong>.",
    "invalid-email": "Въведете валиден имейл адрес",
    "manager-failed": "Неуспешен вход. Моля, уверете се, че имейлът и паролата са въведени коректно, и опитайте отново.",
    "manager-title": "Административен достъп за <strong>управители</strong> в FSAcademy",
    "password-login-link": "Вход с парола",
    "privacy-login": "С натискането на бутона <strong>Влез</strong> се съгласявате с <PrivacyLink>политиката за лични данни</PrivacyLink>",
    "privacy-send": "С натискането на бутона <strong>Изпрати</strong> се съгласявате с <PrivacyLink>политиката за лични данни</PrivacyLink>",
    "send": "Изпрати",
    "start-over": "Започни отначало",
    "submit": "Влез",
    "success-toast": "Успешен вход"
  },
  "manager": {
    "all-locations": "Всички обекти",
    "column": {
      "login": "Вход в системата"
    },
    "form": {
      "admin-only-warning": "Само <strong>управител</strong> с ниво на достъп <strong>Администратор</strong> може да редактира <strong>Ниво на достъп</strong> и <strong>Обекти</strong>.",
      "email-notification": "Използвай този имейл за известяване",
      "invalid-email": "Невалиден имейл",
      "locations-required": "Трябва да изберете поне един обект",
      "new-title": "Нов управител",
      "new-title-named": "Нов управител: <Name/>",
      "no-locations-selected": "Няма избрани обекти",
      "password-copied": "Новата парола е копирана в клипборда",
      "password-min": "Паролата трябва да бъде поне 8 символа",
      "password-required": "Паролата е задължителна",
      "passwords-mismatch": "Паролите не съвпадат",
      "phone-notification": "Използвай този телефон за известяване",
      "save-error": "Грешка при записване на управителя: {{message}}. Моля опитайте отново",
      "suggest-password": "Предложи силна парола"
    },
    "list": {
      "add": "Добави управител",
      "disable-hint": "Достъпът на избраните управители ще бъде прекратен",
      "disable-message_one": "Сигурни ли сте че искате да деактивирате следния управител:",
      "disable-message_other": "Сигурни ли сте че искате да деактивирате следните управители:",
      "disable-title": "Деактивиране на управители",
      "edit-tooltip": "Редактиране на управител",
      "enable-hint": "Достъпът на избраните управители ще бъде възстановен",
      "enable-message_one": "Сигурни ли сте че искате да активирате следния управител:",
      "enable-message_other": "Сигурни ли сте че искате да активирате следните управители:",
      "enable-title": "Активиране на управители",
      "login-as-tooltip": "Влез като този управител",
      "login-email-message": "Сигурни ли сте че искате да изпратите имейл за вход в системата на {{name}}?",
      "login-email-title": "Изпращане на имейл за вход",
      "login-email-toast": "Имейлът за вход в системата е изпратен",
      "no-locations": "Няма обекти",
      "send-login-email-tooltip": "Изпрати имейл за вход в системата на <Name/>",
      "test-send-message": "Сигурни ли сте че искате да изпратите тестово съобщение на {{name}}?",
      "test-send-title": "Изпращане на тестово съобщение",
      "test-send-toast": "Успешно изпратено тестово съобщение",
      "test-send-tooltip": "Изпращане на тестово съобщение по всички активни канали",
      "title": "Управители"
    },
    "role": {
      "admin": "Администратор",
      "manager": "Избрани обекти"
    }
  },
  "nav": {
    "admin": {
      "clients": "Клиенти",
      "features": {
        "allow-seeking": "Превъртане напред",
        "control-card-extras": "Допълнителни функции в контролните карти",
        "disable-chapters": "Не спирай на сегментите на видеото",
        "highlight-answers": "Покажи верните отговори",
        "test-notifications": "Тестови известия",
        "transfer-device": "Прехвърляне на друго устройство",
        "video-stats": "Видео статистика в плейъра"
      },
      "levels": "Нива",
      "reload-employees": "Презареди служители",
      "revision": "Ревизия: {{revision}}",
      "revision-updated": "Обновяване: <Ts/>",
      "support-agents": "Агенти Поддръжка",
      "system": "Системни",
      "video-lessons": "Видео Уроци",
      "welcome": "Добре дошли в административната част на FSAcademy.bg"
    },
    "client-home": {
      "broadcasts": "Известия",
      "edit": "Редактиране",
      "employees-tooltip": "Управление на служители",
      "locations-tooltip": "Управление на обекти",
      "managers-tooltip": "Управление на управители",
      "planning": "Планиране",
      "positions-tooltip": "Управление на длъжности"
    },
    "home": "Начало",
    "logout": "Изход",
    "manager": {
      "barsy-settings": "Barsy настройки",
      "broadcasts": "Изпращане на известия",
      "control-cards": "Контролни карти",
      "employees": "Служители",
      "incoming-control": "Входящ контрол",
      "locations": "Обекти",
      "managers": "Управители",
      "mark-all-read": "Маркирай всички като прочетени",
      "no-new-notifications": "Няма нови",
      "notifications": "Известия ({{unread}})",
      "notifications-header": "Известия (<strong>{{unread}}</strong> непрочетени)",
      "positions": "Длъжности",
      "refresh-notifications": "Обнови известията",
      "tickets": "Сигнали",
      "training-plan": "Обучителен план",
      "user-groups": "Групи потребители"
    },
    "my-profile": "Моят профил",
    "test-mode": "Тестов режим"
  },
  "organizer": {
    "archive-button-label": "Архивирай",
    "archive-document-message": "Сигурни ли сте че искате да архивирате документа \"{{name}}\"?",
    "archive-document-title": "Архивиране на документ",
    "archive-folder-message": "Сигурни ли сте че искате да архивирате папката \"{{name}}\" заедно с ВСИЧКИ документи в нея?",
    "archive-folder-title": "Архивиране на папка",
    "column": {
      "state": "Състояние",
      "valid-from": "От дата",
      "valid-until": "Изтича на"
    },
    "create-document": "Създай документ",
    "create-folder": "Създай папка",
    "expiration": {
      "expired": "Изтекъл",
      "expires-soon": "Изтича скоро"
    },
    "export": "Експорт",
    "export-tooltip_one": "Експортът ще съдържа избрания {{count}} документ.",
    "export-tooltip_other": "Експортът ще съдържа избраните {{count}} документи.",
    "folder": {
      "add-title": "Добави папка",
      "edit-title": "Редактиране на папка {{name}}",
      "name-placeholder": "Име на папката",
      "save-error": "Грешка при записване на папката: {{message}}. Моля опитайте отново"
    },
    "folder-tag": {
      "all-ok": "Няма изтекли, изтичащи или незавършени документи",
      "expired_one": "Изтекли: <strong>{{count}} документ</strong>",
      "expired_other": "Изтекли: <strong>{{count}} документа</strong>",
      "expires-soon_one": "Изтичащи: <strong>{{count}} документ</strong>",
      "expires-soon_other": "Изтичащи: <strong>{{count}} документа</strong>",
      "pending_one": "Незавършени: <strong>{{count}} документ</strong>",
      "pending_other": "Незавършени: <strong>{{count}} документа</strong>"
    },
    "form": {
      "add-title": "Добави документ",
      "current-state": "Текущо състояние",
      "duration-1-month": "1 месец",
      "duration-1-year": "1 година",
      "duration-2-years": "2 години",
      "duration-3-months": "3 месеца",
      "duration-6-months": "6 месеца",
      "earlier": "по-рано",
      "edit-title": "Редактиране на документ {{name}}",
      "folder": "Папка",
      "folder-placeholder": "Изберете папка",
      "folder-required": "Изберете папка",
      "name-placeholder": "Име на документа, например Разрешително за...",
      "notes-placeholder": "Допълнителни бележки (ако има нужда)",
      "quick-durations": "Бързи срокове:",
      "reminder": "Изпрати ми напомняне",
      "reminder-description": "Ще изпратим предупреждаващо известие преди да изтече документа",
      "valid-from": "Дата на издаване",
      "valid-from-placeholder": "Оставете празно ако няма дата на издаване",
      "valid-until-description": "Ще изпратим известие при изтичане на документа",
      "valid-until-placeholder": "Оставете празно ако няма срок"
    },
    "no-date": "Няма дата",
    "no-expiration": "Безсрочен",
    "no-reminder": "Без напомняне",
    "notification-sent": "Известието за документ <Name/> е изпратено",
    "reminder-line": "<strong>Напомняне:</strong> <Dur/> по-рано",
    "state": {
      "complete": "Завършен",
      "pending": "В изчакване"
    },
    "title": "Органайзер за обект <Name/>",
    "tooltip": {
      "archive-document": "Архивиране на документа <Name/>",
      "archive-folder": "Архивиране на папката <Name/>",
      "download-pdf": "Изтегляне на документа <Name/> като PDF",
      "edit-document": "Редактиране на документа <Name/>",
      "edit-folder": "Редактиране на папка <Name/>",
      "send-notification": "Изпращане на известие сега"
    }
  },
  "planning": {
    "column": {
      "type-period": "Тип / Период"
    },
    "create-full": "Създай встъпително обучение",
    "create-refresh": "Създай опреснително обучение",
    "delete-message": "Сигурни ли сте че искате да изтриете този ред?",
    "delete-title": "Изтриване на план",
    "full": {
      "completion-time": "Време за приключване на встъпителното обучение",
      "days-suffix_one": "ден от започване на работа",
      "days-suffix_other": "дни от започване на работа"
    },
    "no-plans": "Няма създадени планове",
    "refresh": {
      "beyond-contract": "След края на договора",
      "contract-tooltip": "Договорът с FSAcademy изтича преди тази дата, на <Date/>. Необходимо е да подновите Вашия абонамент",
      "end": "Край",
      "end-before-start": "Краят на това обучение не може да бъде преди началото му",
      "overlap": "Това обучение се застъпва с обучението между {{from}} и {{to}}",
      "period": "Период:",
      "period-range": "от <From/> до <To/>",
      "start": "Начало"
    },
    "row": {
      "lesson-count": "Брой теми: <strong>{{total}}</strong>",
      "selected-lessons": "Избрани теми: <strong>{{selected}} от {{total}}</strong>"
    },
    "title": "Годишен план за обучение"
  },
  "position": {
    "form": {
      "new-title": "Нова длъжност",
      "new-title-named": "Нова длъжност: <Name/>"
    },
    "list": {
      "add": "Добави нова длъжност",
      "edit-tooltip": "Редактиране на длъжност",
      "title": "Длъжности"
    }
  },
  "schedule": {
    "day": {
      "fri": "петък",
      "mon": "понеделник",
      "sat": "събота",
      "sun": "неделя",
      "thu": "четвъртък",
      "tue": "вторник",
      "wed": "сряда"
    },
    "day-full": {
      "fri": "Петък",
      "mon": "Понеделник",
      "sat": "Събота",
      "sun": "Неделя",
      "thu": "Четвъртък",
      "tue": "Вторник",
      "wed": "Сряда"
    },
    "day-of-month": "Ден от месеца",
    "edit-title": "Редактиране на <Label/>",
    "every-day": "Всеки ден",
    "every-month": "Всеки месец",
    "fallback-label": "график",
    "frequency": "Периодичност",
    "human": {
      "day-fallback": "{{day}} ден",
      "every-day": "всеки ден",
      "first-workday": "На първия работен ден",
      "last-day": "На последния ден от месеца",
      "last-nth-day": "последният {{day}} от месеца",
      "last-workday": "На последния работен ден от месеца",
      "nth-day": "{{pos}} {{day}} от месеца",
      "on-day": "на {{ordinal}} число от месеца",
      "sentence": "{{dayPart}} в {{time}}{{monthPart}}"
    },
    "mode": {
      "day-of-month": "По ден от месеца",
      "day-of-week": "По ден от седмицата",
      "nth-day-of-week": "По ден от седмицата в месеца"
    },
    "month": {
      "apr": "Април",
      "aug": "Август",
      "dec": "Декември",
      "feb": "Февруари",
      "jan": "Януари",
      "jul": "Юли",
      "jun": "Юни",
      "mar": "Март",
      "may": "Май",
      "nov": "Ноември",
      "oct": "Октомври",
      "sep": "Септември"
    },
    "months": "Месеци",
    "none": "Без график",
    "nth": {
      "first": "първият",
      "fourth": "четвъртият",
      "second": "вторият",
      "third": "третият"
    },
    "nth-option": {
      "first": "Първият",
      "fourth": "Четвъртият",
      "last": "Последният",
      "second": "Вторият",
      "third": "Третият"
    },
    "preset": {
      "first-workday": "На първия работен ден",
      "last-day": "На последния ден",
      "last-workday": "На последния работен ден",
      "on-day": "На {{ordinal}} число"
    },
    "preview": {
      "calculating": "Изчисляване...",
      "invalid": "Невалиден график",
      "request-error": "Грешка при заявката"
    },
    "preview-dates": "Дати на избрания график",
    "quick": {
      "every-day": "Всеки ден в 6 часа",
      "every-monday": "Всеки понеделник в 6 часа",
      "every-workday": "Всеки работен ден в 6 часа",
      "first-day-of-month": "Първо число на месеца в 6 часа",
      "first-monday-of-month": "Първият понеделник на месеца в 6 часа",
      "first-workday-of-month": "Първият работен ден на месеца в 6 часа",
      "label": "Бърз график",
      "placeholder": "Изберете шаблон..."
    },
    "time": "Час",
    "type-disabled": "Без график",
    "type-enabled": "С график"
  },
  "ticket": {
    "column": {
      "control-card": "Контролна карта",
      "created": "Създаден",
      "files": "Файлове",
      "subject": "Тема",
      "to": "До",
      "updated": "Обновен"
    },
    "delete": {
      "message": "Сигурни ли сте, че искате да изтриете сигнал <Number/>?",
      "message-with-subject": "Сигурни ли сте, че искате да изтриете сигнал <Number/>: {{subject}}?",
      "title": "<mark>Изтриване</mark> на сигнал",
      "toast": "Сигнал {{number}} е изтрит успешно"
    },
    "detail": {
      "change-status": "Промяна на статус",
      "delete-toast": "Сигналът е изтрит успешно",
      "join": "Присъединяване",
      "join-error": "Грешка при присъединяване",
      "join-toast": "Присъединихте се към сигнала",
      "join-tooltip": "Добавете себе си като получател на сигнала",
      "leave": "Напускане",
      "leave-error": "Грешка при напускане",
      "leave-toast": "Напуснахте сигнала",
      "leave-tooltip": "Премахнете себе си от получателите на сигнала",
      "loading-title": "Зареждане...",
      "message-placeholder": "Напишете съобщение...",
      "messages": "Съобщения ({{messages}})",
      "new-message": "Ново съобщение",
      "status-change-error": "Грешка при промяна на статус",
      "status-changed-by": "Статус променен от {{name}} — <Ts/>",
      "status-changed-toast": "Статусът е променен на \"{{status}}\"",
      "status-message": "{{name}} промени статуса на „{{status}}“ — <Ts/>",
      "title": "Сигнал <Number/>"
    },
    "for-locations": "За обекти",
    "form": {
      "content-placeholder": "Добавете подробности, които биха помогнали за решението на сигнала",
      "edit-title": "Редактиране на сигнал #{{number}}",
      "locations-description": "За кои обекти се отнася сигнала, ако е приложимо",
      "locations-placeholder": "Изберете обекти",
      "recipients-required": "Изберете поне един получател",
      "save-error": "Грешка при записване: {{message}}. Моля опитайте отново",
      "subject-placeholder": "За какво се отнася сигнала"
    },
    "list": {
      "add": "Нов сигнал",
      "title": "Сигнали",
      "view-files": "Виж ({{files}})"
    },
    "recipients": {
      "manager": "Управител",
      "only-employees": "Само служители",
      "only-managers": "Само управители",
      "search-placeholder": "По име, длъжност или обект",
      "title": "Избор на получатели"
    },
    "search": {
      "direction": "Посока",
      "for-me": "За мен",
      "from-me": "От мен",
      "no-location": "Без обект",
      "placeholder": "Търсене в сигнали..."
    },
    "status": {
      "done": "Приключен",
      "in-progress": "Изпълнява се",
      "todo": "За изпълнение"
    }
  },
  "user-group": {
    "archive": {
      "message_one": "Сигурни ли сте, че искате да архивирате избраната група?",
      "message_other": "Сигурни ли сте, че искате да архивирате избраните {{count}} групи?",
      "note": "Контролните карти, които вече използват тези групи, ще продължат да филтрират потребителите по тях, докато не бъдат премахнати от съответната колона. Архивираните групи не могат да бъдат избирани отново.",
      "title": "Архивиране на групи",
      "toast-errors": "Грешки при архивиране: {{errors}}",
      "toast-success_one": "Архивирана {{count}} група",
      "toast-success_other": "Архивирани {{count}} групи",
      "toast-title": "Резултат от архивирането"
    },
    "column": {
      "member-count": "Брой потребители"
    },
    "form": {
      "load-error": "Грешка при зареждане на групата.",
      "members": "Потребители ({{members}})",
      "members-empty": "Изберете потребители",
      "new-title": "Нова група",
      "new-title-named": "Нова група: <Name/>",
      "save-error": "Грешка при записване на групата: {{message}}. Моля опитайте отново",
      "save-success": "Успешен запис на група {{name}}"
    },
    "list": {
      "add": "Добави нова група",
      "archive-restore": "Архивиране / Възстановяване …",
      "archived-icon": "Групата е архивирана",
      "edit-tooltip": "Редактиране на група",
      "title": "Групи потребители"
    },
    "restore": {
      "toast-errors": "Грешки при възстановяване: {{errors}}",
      "toast-success_one": "Възстановена {{count}} група",
      "toast-success_other": "Възстановени {{count}} групи",
      "toast-title": "Резултат от възстановяването"
    },
    "search": {
      "include-archived": "Покажи и архивирани",
      "placeholder": "По име"
    }
  },
  "video-lesson": {
    "answer": {
      "archive": "Архивирай (скрий) отговора",
      "correct": "Верен отговор",
      "label": "Отговор {{pos}}. (съдържание)",
      "remove": "Премахни този отговор"
    },
    "column": {
      "score-to-pass": "Процент за да мине",
      "title": "Заглавие"
    },
    "form": {
      "add-chapter": "Добави секция",
      "add-question": "Добави въпрос",
      "chapter-count": "Брой секции: ({{chapters}})",
      "chapter-end": "Край на секцията във видеото",
      "new-title": "Нов видео урок",
      "new-title-named": "Нов видео урок: <Name/>",
      "no-chapters": "Няма дефинирани секции",
      "remove-chapter": "Премахни тази секция",
      "saved-toast": "Готово",
      "score-to-pass": "Необходим процент от верни отговори за успешно преминаване",
      "tab": {
        "chapters": "Секции",
        "main": "Основни",
        "questions": "Въпроси към теста",
        "test": "Тест към урока"
      },
      "thumbnail": "Статично изображение",
      "video-files": "Видео файлове"
    },
    "length": "Продължителност",
    "list": {
      "add": "Добави нов видео урок",
      "edit-tooltip": "Редактиране на видео урок",
      "title": "Видео уроци"
    },
    "player": {
      "rewind": "Превърти"
    },
    "question": {
      "add-answer": "Добави отговор",
      "answer-end": "Край на относима част от видеото",
      "answer-start": "Начало на относима част от видеото",
      "answers-title": "Отговори на въпроса",
      "archive": "Архивирай (скрий) въпроса",
      "remove": "Премахни този въпрос",
      "required-to-pass": "Задължителен за успешно преминаване на теста",
      "score": "Точки",
      "title": "Въпрос №{{pos}}"
    },
    "watch": "Гледай",
    "watch-excerpt": "Гледай откъса"
  }
}
